import { useEffect } from 'react';

const WALLET_SYNC_INTERVAL_MS = 60_000;

export const useVisibleWalletSync = ({
  enabled,
  requestSync,
}: {
  enabled: boolean;
  requestSync: () => void;
}) => {
  useEffect(() => {
    if (!enabled) return;

    let interval: ReturnType<typeof setInterval> | undefined;
    const stopInterval = () => {
      if (interval) clearInterval(interval);
      interval = undefined;
    };
    const startVisibleSync = () => {
      stopInterval();
      if (document.visibilityState !== 'visible') return;
      requestSync();
      interval = setInterval(requestSync, WALLET_SYNC_INTERVAL_MS);
    };

    startVisibleSync();
    document.addEventListener('visibilitychange', startVisibleSync);
    return () => {
      stopInterval();
      document.removeEventListener('visibilitychange', startVisibleSync);
    };
  }, [enabled, requestSync]);
};
